<div class="bcg_esign " style="justify-content: center; align-items: center; display: flex;">
    <div class="card card_outLine">

        <div style="padding: 3rem 5rem;">
            <img src="/assets/img/animation-crop.gif" class="sign-animation" alt="animation">
            <div style="display: flex; justify-content: center; align-items: center;">
                <img class="clickable" src="../../assets/img/new-logo.png" height="60">
            </div>

            <div class="my-4" style="display: flex; justify-content: center;">
                <img src="../../../assets/img/sign-completed.png" height="60">
            </div>

            <div class="action-buttons mt-4" *ngIf="!isHashSign">
                <button class="action-btn email-btn" (click)="shareToEmail()" [disabled]="isEmailButtonDisabled"
                    [class.disabled]="isEmailButtonDisabled">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <span *ngIf="!isEmailButtonDisabled">Email to me</span>
                    <span *ngIf="isEmailButtonDisabled">Wait {{ emailCooldownTime }}s</span>
                </button>

                <button class="action-btn print-btn" (click)="printDocument()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="6 9 6 2 18 2 18 9"></polyline>
                        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                        <rect x="6" y="14" width="12" height="8"></rect>
                    </svg>
                    Print
                </button>

                <button class="action-btn download-btn" (click)="downloadDocument()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                    Download
                </button>
            </div>
            <div class="mt-3">
                <div class="p-3">
                    <h4 class="title_five" style="
            font-size: 16px;
            display: flex;
            justify-content: center;
            text-align: center;
            top: 1rem;
            position: relative;
          ">Document Signed Successfully</h4>
                </div>
                <p *ngIf="isHashSign" class="r1s_small text-center mt-3 mb-0">
                    Your signature over the document hash has been recorded and sent to the requesting organisation.
                </p>
                <div class="p-1 mt-1">
                    <h4 class="title_five home-page-link">
                        <a href=" ">Go to the Doqfy login page</a>
                    </h4>
                </div>
            </div>

        </div>

    </div>
</div>